import { type IMaxPlanRulesContentProps } from "../types/types";
import { HouseInsuranceRulesFiles } from "./HouseInsuranceRulesFiles";

export const HouseInsuranceRulesContent: React.FC<
  IMaxPlanRulesContentProps
> = ({ title, hideTitle }) => {
  return (
    <div className="gap-6">
      {!hideTitle && title && <h4 className="my-5">{title}</h4>}
      <h5 className="my-4">
        Šis draudimo paketas apsaugos jus nuo nuostolių, jeigu dėl jūsų namuose
        įvykusios nelaimės teks remontuoti ir kaimynų butą. Kartu su šiuo
        draudimu, padovanosime asmens civilinės atsakomybės draudimą, kuris
        padengs nuostolius, jeigu jūs ar šeimos nariai sugadins kitą svetimą
        turtą.
      </h5>
      <ul className="my-4">
        <li>
          <b>Būsto valdytojo civilinės atsakomybės draudimas</b> padengia
          svetimam (ar bendro naudojimo) kilnojamam bei nekilnojamam turtui
          padarytus nuostolius, kurie įvyksta dėl: technikos gedimo, gaisro,
          gamtinių stichijų, vandens žalos. Draudiminė suma iki 9000 €.
        </li>
        <li>
          <b>Asmens civilinės atsakomybės draudimas</b> padengia nuostolius,
          padarytus tretiesiems asmenims, jų sveikatai, gyvybei, kilnojamam bei
          nekilnojamam turtui ir veikia visoje Lietuvos Respublikoje. Jis apima:
          netyčinę žalą, padarytą naudojantis dviračiu, paspirtuku, riedžiu,
          vaikišku arba neįgaliojo vežimėliu, Jūsų augintinio ar trečiajam
          asmeniui sutrikdytą sveikatą ar sugadintą svetimą turtą. Draudiminė
          suma, taip pat iki 9000 €.
        </li>
        <li>
          Kad draudimas įsigaliotų, jums tereikia pasirinkti „Viena sąskaita“
          paslaugos planą „Maksimalus“ ir apmokėti pateiktą įmoką. Kol galios
          paslaugos planas, tol galios ir jūsų pasirinkta draudimo apsauga.
        </li>
      </ul>
      <h5 className="my-4">Draudimo užsakymas ir galiojimas:</h5>
      <ul className="my-4">
        <li>
          Draudimą galite užsakyti, pasirinkdami „Viena sąskaita“ paslaugos
          planą „Maksimalus“ ir nurodydami pasirinktą draudimo apsaugą.
        </li>
        <li>
          Draudimas įsigalioja tada, kai apmokate „Viena sąskaita“ paslaugos
          planą „Maksimalus“ ir sulaukiate draudimo sertifikato. Draudimo
          sertifikato ir patvirtinimo apie draudimo įsigaliojimą gali tekti
          laukti dieną ar daugiau. Taip yra todėl, kad įmoka už paslaugos planą
          mes gauname tik kitą darbo dieną, ir tik patikrinę informaciją,
          paruošiame draudimo sertifikatą. Dėl draudimo sertifikato kreipkitės
          tuomet, jeigu jo nebūsite gavę ilgiau kaip dvi darbo dienos po atlikto
          mokėjimo.
        </li>
        <li>
          Įsigaliojus draudimui, apie tai atskirai jus informuosime SMS žinute
          ir atsiųsime patvirtinimą į paskyrą.
        </li>
        <li>
          Draudimo sertifikatą ir kitus dokumentus, pirmą kartą po paslaugos
          užsakymo, jums išsiųsime el. paštu, kuris bus nurodytas paslaugos
          užsakymo metu.
        </li>
        <li>
          Draudimo apsauga galios kol jūsų paskyroje bus aktyvus „Viena
          sąskaita“: paslaugos planas „Maksimalus“ ir kol reguliariai gausime
          įmokas už šį paslaugos planą.
        </li>
        <li>
          Jeigu bent vieną mėnesį neatliksite mokėjimo už „Viena sąskaita“
          paslaugos planą „Maksimalus“ iki mėnesio paskutinės dienos, draudimas
          bus atšauktas, o paslaugos planas bus pakeistas į kitą planą.
        </li>
        <li>
          Jeigu dėl pavėluotos įmokos bus atšauktas planas „Maksimalus“ ir
          nutrauktas draudimo galiojimas, 3 mėnesius neturėsite galimybės
          užsisakyti šios paslaugos iš naujo.
        </li>
        <li>
          Draudimo sertifikatas – visada bus jūsų Viena sąskaita paskyroje, o
          nutikus draudiminiam įvykiui visus dokumentus pateikti ir įvykį
          registruoti reikia susisiekus su draudimo brokeriu – EDRAUDA (
          <a href="mailto:info@edrauda.lt">info@edrauda.lt</a> arba +370 644 42
          224).
        </li>
      </ul>
      <h5 className="my-4">
        Draudimo dokumentai, su kuriais privaloma susipažinti prieš užsakant
        draudimo paslaugą:
      </h5>
      <HouseInsuranceRulesFiles />
    </div>
  );
};
